module.exports = __webpack_public_path__ + "7dba93149f3d646c27f255ddcd694c41.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Yummy/images/backgrounds/1.png
// module id = 31
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18